import { AlertIcon, CloseIcon } from './ui/Icon.js';
import styles from './Notice.module.css';

export interface NoticeProps {
  readonly message: string;
  onDismiss: () => void;
}

/** Transient server rejections — "only the host can do that", and friends. */
export function Notice({ message, onDismiss }: NoticeProps) {
  return (
    <div className={styles.notice} role="status">
      <span className={styles.icon}>
        <AlertIcon size={15} />
      </span>
      <span className={styles.text}>{message}</span>
      <button type="button" className={styles.dismiss} onClick={onDismiss} aria-label="Dismiss">
        <CloseIcon size={15} />
      </button>
    </div>
  );
}
